module.exports = __webpack_public_path__ + "img/uploading-white.425fea9b.svg";